import { ROLES, isFlightCrewRole } from '../constants/roles';

export const CREW_CLEARANCE_CONFIG = [
  { field: 'isVipCleared', label: 'VIP cleared', formLegend: 'VIP cleared?' },
  { field: 'isIrCleared', label: 'IR', formLegend: 'IR?' },
  { field: 'isHillCleared', label: 'HILL', formLegend: 'HILL?' },
  { field: 'isCpCleared', label: 'CP', formLegend: 'CP?' },
  { field: 'isTriCleared', label: 'TRI', formLegend: 'TRI?' },
  { field: 'isTreCleared', label: 'TRE', formLegend: 'TRE?' },
  { field: 'isChplCleared', label: 'CHPL', formLegend: 'CHPL?' },
  { field: 'isAtplCleared', label: 'ATPL', formLegend: 'ATPL?' },
  { field: 'isDualTypeCleared', label: 'Dual Type', formLegend: 'Multiple type (qualified on Multiple types)?' }
];

export const CREW_CLEARANCE_POPULATE =
  'isVipCleared isIrCleared isHillCleared isCpCleared isTriCleared isTreCleared isChplCleared isAtplCleared isDualTypeCleared';

export function isCrewRosterHighlightCleared(crew) {
  if (!crew) return false;
  return CREW_CLEARANCE_CONFIG.some(({ field }) => crew[field] === true);
}

export function crewClearanceToFormValue(val) {
  if (val === true) return 'yes';
  if (val === false) return 'no';
  return '';
}

export function formValueToCrewClearance(val) {
  if (val === 'yes') return true;
  if (val === 'no') return false;
  return undefined;
}

export function emptyCrewClearanceFormValues() {
  return CREW_CLEARANCE_CONFIG.reduce((acc, { field }) => {
    acc[field] = '';
    return acc;
  }, {});
}

export function crewClearanceFromUser(user) {
  if (!user || !isFlightCrewRole(user.role)) return emptyCrewClearanceFormValues();
  return CREW_CLEARANCE_CONFIG.reduce((acc, { field }) => {
    acc[field] = crewClearanceToFormValue(user[field]);
    return acc;
  }, {});
}

export function appendCrewClearancePayload(payload, role, formData) {
  if (!isFlightCrewRole(role)) return payload;
  CREW_CLEARANCE_CONFIG.forEach(({ field }) => {
    const value = formValueToCrewClearance(formData[field]);
    if (value !== undefined) payload[field] = value;
  });
  return payload;
}

export function formatCrewClearanceYesNo(val) {
  if (val === true) return 'Yes';
  if (val === false) return 'No';
  return '—';
}
